import { render, staticRenderFns } from "./ItemProps.vue?vue&type=template&id=6f968d72"
import script from "./ItemProps.vue?vue&type=script&lang=js"
export * from "./ItemProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports